/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Cells of a layout thumbnail, drawn with the same spans the canvas uses.
 */
const LayoutThumbnailApp = ({ type }) => {
    const columns = type?.PREVIEW_COLUMNS ?? type?.COLUMNS ?? 3;
    const cells = (type?.PREVIEW ?? type?.SLOTS ?? []).map((slot, index) => ({
        key: `${type?.ID}-${index}`,
        add: !!slot.add,
        className: `event-monitoring-thumbnail-cell border-radius-4px event-monitoring-col-span-${slot.colSpan} event-monitoring-row-span-${slot.rowSpan} ${slot.add ? 'border-dashed-primary-500-2px background-primary-50' : 'border-full-primary-500-2px background-primary-100'}`,
    }));

    return {
        gridClassName: `event-monitoring-thumbnail w-100px h-76px event-monitoring-grid-cols-${columns}`,
        cells
    };
};

export default LayoutThumbnailApp;
